import type { FC, TextareaHTMLAttributes } from "react";

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  hidden?: boolean;
};

const ApprovalHistoryInput: FC<Props> = (props) => {
  const { hidden, ...rest } = props;

  if (hidden) {
    return null;
  }

  return (
    <div className="input">
      <textarea placeholder="Nhập lưu ý, lý do phê duyệt" {...rest} />
    </div>
  );
};

export default ApprovalHistoryInput;
